// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Bobx
import { observer, inject } from "mobx-react";

// MARK: Components
import { Typography } from "@material-ui/core";

// MARK: Resource
import strings from "../../../resources/strings";

interface IProps {
}

@inject("authStore")
@observer
export default class Home extends React.Component<IProps> {
	public render = () => {
		return (
			<div className="homeContainer">
				<Typography variant="h4">{strings.home.welcome}</Typography>
			</div>
		);
	}
}
